import type { Cashbox } from '@/types/api'
import { createCrudService } from '../crud'

export type CashboxInput = { branch_id: string; name: string; is_active: boolean }

export const cashboxesService = createCrudService<Cashbox, CashboxInput>('cashboxes')
